import React from "react";
import { getStaffingColor, formatPercent, formatNumber } from "./utils";

const icons = {
  plan: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
        fill="currentColor"
      />
    </svg>
  ),
  fact: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        fill="currentColor"
      />
    </svg>
  ),
  staffing: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
        fill="currentColor"
      />
    </svg>
  ),
  deficit: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="currentColor" />
    </svg>
  ),
  turnover: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
        fill="currentColor"
      />
    </svg>
  ),
};

function KpiCards({ summary }) {
  const cards = [
    {
      key: "plan",
      title: "Плановая численность",
      value: formatNumber(summary.plannedHeadcount),
      subtitle: "По штатному плану",
      icon: icons.plan,
      tone: "neutral",
    },
    {
      key: "fact",
      title: "Фактическая численность",
      value: formatNumber(summary.actualHeadcount),
      subtitle: "Активные сотрудники",
      icon: icons.fact,
      tone: "blue",
    },
    {
      key: "staffing",
      title: "Укомплектованность",
      value:
        summary.staffingPercent != null
          ? `${summary.staffingPercent}%`
          : "—",
      subtitle: "Факт / план",
      icon: icons.staffing,
      tone: summary.staffingBadge?.tone || "neutral",
      badge: summary.staffingBadge?.text,
      progress: summary.staffingPercent,
    },
    {
      key: "deficit",
      title: "Дефицит",
      value:
        summary.deficit != null ? formatNumber(summary.deficit) : "—",
      subtitle: "Не хватает сотрудников",
      icon: icons.deficit,
      tone: summary.deficitBadge?.tone || "neutral",
      badge: summary.deficitBadge?.text,
    },
    {
      key: "turnover",
      title: "Текучесть",
      value: formatPercent(summary.turnoverPercent),
      subtitle: "За выбранный период",
      icon: icons.turnover,
      tone: "orange",
      note:
        summary.turnoverAboveNorm != null
          ? `+${formatPercent(summary.turnoverAboveNorm).replace("%", "")}% выше нормы`
          : null,
    },
  ];

  return (
    <div className="hr-dashboard__kpi-grid">
      {cards.map((card) => (
        <article
          key={card.key}
          className={`hr-dashboard__kpi-card hr-dashboard__kpi-card--${card.tone}`}
        >
          <div className="hr-dashboard__kpi-top">
            <div>
              <p className="hr-dashboard__kpi-title">{card.title}</p>
              <p className="hr-dashboard__kpi-value">{card.value}</p>
              <p className="hr-dashboard__kpi-subtitle">{card.subtitle}</p>
            </div>
            <div className="hr-dashboard__kpi-icon">{card.icon}</div>
          </div>
          {card.badge && (
            <span className={`hr-dashboard__badge hr-dashboard__badge--${card.tone}`}>
              {card.badge}
            </span>
          )}
          {card.note && (
            <span className="hr-dashboard__kpi-note">{card.note}</span>
          )}
          {card.progress != null && (
            <div className="hr-dashboard__kpi-progress">
              <div
                className={`hr-dashboard__kpi-progress-fill hr-dashboard__kpi-progress-fill--${getStaffingColor(card.progress)}`}
                style={{ width: `${Math.min(card.progress, 100)}%` }}
              />
            </div>
          )}
        </article>
      ))}
    </div>
  );
}

export default KpiCards;
